export enum SCHEDULE_CODE_TYPE {
  EXAM = 2,
  CONSULTATION = 3,
  SURGERY = 1
}
